export const RETURN_METHOD_TYPE = {
  CARRIER: 'CARRIER',
  STORE_DROP_OFF: 'STORE_DROP_OFF',
  HOME_PICKUP: 'HOME_PICKUP',
};

export default RETURN_METHOD_TYPE;
